<template>
  <div class="modal" v-if="seen">
    <div class="deletefile">
      <span @click="closebox" class="closefile">
        <img src="@/assets/Close Button.svg" />
      </span>
      <div class="d-flex justify-content-center align-items-center mt-4">
        <img src="@/assets/trash-can.svg" />
      </div>
      <div class="header d-flex justify-content-center align-items-center mt-2">
        <h6><strong>Delete file?</strong></h6>
      </div>
      <div class="cgn text-center my-2">
        <span>Are you want to delete permanently <strong>{{ str_text(name) }}</strong> from your drive or move to
          trash?</span>
      </div>
      <div class="save">
        <span class="btn-delete-permanently" @click="permanent">
          Delete permanently
        </span>
      </div>
    </div>
  </div>
</template>
<style scoped>
.header {
  padding: .5em 0 0 0 !important;
}

.header h3 {
  font-size: 22px;
  font-weight: bold;
}

.save {
  margin-top: 0 !important;
}

.cgn {
  display: flex;
  flex-direction: column;
}

.cgn span {
  margin-bottom: .4em;
  font-size: 14px;
}

.deletefile {
  padding: 2em !important;
}

.modal div.deletefile {
  width: 420px !important;
}

.modal div.deletefile div {
  width: 100% !important;
  margin-left: 0 !important;
}

.save {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.save span {
  flex: 1 !important;
}

.save .btn-move-to-trash {
  background: #3F96D1 !important;
  color: #fff !important;
  font-size: 13px !important;
}

.save .btn-delete-permanently {
  background: #FC6D6C !important;
  border: 1px solid #FC6D6C !important;
  font-size: 13px !important;
  color: #fff !important;
}

.save .btn-delete {
  background: transparent !important;
  border: 1px solid #FC6D6C !important;
  font-size: 13px !important;
  color: #FC6D6C !important;
}

.modal div.deletefile .closefile {
  top: 13px !important;
  right: 13px !important;
}
</style>

<script>
import cookies from '@/services/cookies'
export default {
  data() {
    return {
      name: '',
      seen: false,
      index: null,
      loader: false,
      error: false,
      id: null,
      found: false,
      is_public: false,
      src: ''
    }
  },
  methods: {
    logincall() {
      this.$parent.logincall()
    },
    str_text(str) {
      return str.length > 22 ? str.substr(0, 22) + '...' : str
    },
    load(index, id, src = '') {
      this.seen = true
      this.index = index
      this.error = false
      this.loader = false
      this.found = false
      this.id = id,
        this.src = src
      this.name = this.$store.getters.DIRECTORY_CHILDREN[index].dir
      this.is_public = this.$store.getters.DIRECTORY_CHILDREN[index].is_public
    },
    permanent() {
      this.seen = false
      this.$parent.permanent(this.index, this.id, this.src)
    },
    closebox() {
      this.seen = false
    }
  }
}
</script>
